import { render, staticRenderFns } from "./ProductListPage.vue?vue&type=template&id=31ceca5a&scoped=true&"
import script from "./ProductListPage.vue?vue&type=script&lang=js&"
export * from "./ProductListPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductListPage.vue?vue&type=style&index=0&id=31ceca5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ceca5a",
  null
  
)

export default component.exports